import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gestor-directorio-medico',
  templateUrl: './gestor-directorio-medico.component.html',
  styleUrls: ['./gestor-directorio-medico.component.scss']
})
export class GestorDirectorioMedicoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
